import vm from '@/main'

const i18n = param => vm.$t(`_staff.labelEdu.${param}`)
export default (form = {}, staffId) => {
  const column = [
    {
      label: i18n('country'),
      field: 'country',
      dictField: 'countryName',
      formOption: {
        type: 'select',
        dictCode: 'nationality',
        rules: 'required',
      },
    },
    {
      label: i18n('university'),
      field: 'university',
      dictField: 'universityName',
      formOption: {
        type: 'select',
        dictCode: 'university',
        dictQuery: {
          code: form.country,
        },
      },
    },
    {
      label: i18n('degree'),
      field: 'degree',
      dictField: 'degreeName',
      formOption: {
        type: 'select',
        dictBizCode: 'qualification',
      },
    },
    {
      label: i18n('faculty'),
      field: 'faculty',
    },
    {
      label: i18n('profession'),
      field: 'profession',
    },
    {
      label: i18n('entryDate'),
      field: 'entryDate',
      type: 'date',
      dateInputFormat: 'yyyy-MM-dd',
      dateOutputFormat: 'MMM do yy',
      formOption: {
        type: 'date',
        rules: 'required',
      },
    },
    {
      label: i18n('graduationDate'),
      field: 'graduationDate',
      type: 'date',
      dateInputFormat: 'yyyy-MM-dd',
      dateOutputFormat: 'MMM do yy',
      formOption: {
        type: 'date',
        rules: 'required',
      },
    },
    {
      label: i18n('certId'),
      field: 'certId',
      dictField: 'certName',
      formOption: {
        type: 'select',
        dictCode: 'cert',
        dictQuery: {
          staffId,
        },
      },
    },
    {
      label: i18n('certificateNumber'),
      field: 'certificateNumber',
    },
  ]
  return column
}
